import { type PropsWithChildren } from 'react';

export function Section({ children, className, id }: PropsWithChildren<{ className?: string; id?: string }>) {
    return (
        <div
            id={id}
            className={`max-w-10xl mx-auto py-8 md:py-24 px-4 flex flex-col relative w-full ${className ?? ''}`}
        >
            {children}
        </div>
    );
}
